'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.progressToolsWidget = function (progressModel) {
	return mmWidgets.each(this, function () {
		const element = this;
		element.on('show', function () {
			progressModel.setActive(true);
		});
		element.on('hide', function () {
			progressModel.setActive(false);
		});
	});

};
